import * as React from 'react';
/**
 *
 * Original name: cloud upload
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29923%3A6830
 *
 */
export const CloudUploadLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M12 6c2.579 0 4.15 1.492 4.245 4.005 2.514.095 4.005 1.67 4.005 4.245 0 2.576-1.491 4.14-4 4.24v-1.507c1.652-.085 2.5-.997 2.5-2.733 0-1.825-.925-2.75-2.75-2.75h-1.25v-1.25c0-1.825-.925-2.75-2.75-2.75s-2.75.925-2.75 2.75v1.25H8c-1.824 0-2.75.925-2.75 2.75 0 1.736.848 2.648 2.5 2.733v1.508c-2.508-.099-4-1.663-4-4.241 0-2.579 1.492-4.15 4.005-4.245C7.85 7.49 9.421 6 12 6Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "m14.885 14.72-1.05 1.071-1.092-1.07v3.77h-1.5v-3.762l-1.075 1.06-1.053-1.067 2.876-2.839 2.894 2.837Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
